export default __webpack_public_path__ + "static/media/1.2af13731.png";